import {ref} from 'vue';

export default {
    install: (app, options) => {
        const profileAdminUser = ref(null);
        const profileAdminUserChannel = ref(null);

        const loadProfileAdminUser = () => {
            window.lazy_axios.get('/dashboard/profile/admin-user')
                .then((response) => {
                    if (response.data.user) {
                        profileAdminUser.value = response.data.user;
                    }
                });
        };

        const resetAll = () => {
            profileAdminUser.value = null;
        };

        app.provide('profileAdminUser', profileAdminUser);
        app.provide('loadProfileAdminUser', loadProfileAdminUser);
        app.provide('profileAdminUserProvider', {
            profileAdminUser,
            loadProfileAdminUser,
            resetAll,
        });
    },
}
